/* esm.sh - @radix-ui/number@1.1.1 */
function m(t,[a,n]){return Math.min(n,Math.max(a,t))}export{m as clamp};
//# sourceMappingURL=number.mjs.map